import { MediaShareService, ShareService } from "../services";

export async function addShare(propertyId, experienceId, userId, data = {}, options = {}) {
  if (userId) {
    const { resp, err } = await ShareService.addShare(propertyId, experienceId, { ...data, options });

    return { shareId: resp?.id, err };
  }

  const { resp, err } = await ShareService.addPublicShare(propertyId, experienceId, { ...data, options });

  return { shareId: resp?.id, err };
}

export async function updateShare(propertyId, experienceId, shareId, userId, data = {}) {
  if (userId) {
    const { resp, err } = await ShareService.updateShare(propertyId, experienceId, shareId, data);

    return { shareId: resp?.id, err };
  }

  const { resp, err } = await ShareService.updatePublicShare(propertyId, experienceId, shareId, data);

  return { resp, err };
}

export async function addMediaShare(propertyId, userId, data = {}, options = {}) {
  if (userId) {
    const { resp, err } = await MediaShareService.addMediaShare(propertyId, { ...data, options });

    return { shareId: resp?.id, err };
  }

  const { resp, err } = await MediaShareService.addPublicMediaShare(propertyId, { ...data, options });

  return { shareId: resp?.id, err };
}

export async function updateMediaShare(propertyId, shareId, userId, data = {}) {
  if (userId) {
    const { resp, err } = await MediaShareService.updateMediaShare(propertyId, shareId, data);

    return { shareId: resp?.id, err };
  }

  const { resp, err } = await MediaShareService.updatePublicMediaShare(propertyId, shareId, data);

  return { resp, err };
}
